module.exports = {
    development : false,
    cloudflare: {
        enabled: true,
        token: '16082753d595462c9d749babc0446ea6'
    },
    wrapper: {
      url: "https://triumphuatapi.eoxvantage.com/"
    },
    ui: {
      url: "https://triumphuat.eoxvantage.com/"
    },
    api: {
      url: "https://triumphuatapi.eoxvantage.com/"
    },
    desktop: {
        settings: {
            font: "Roboto",
            theme: "Vision",
        }
    },
      translateLanguageOptions: ['en','kn','hi','es']
}
